"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SignatureFull_1 = require("./components/SignatureFull");
var React = require("react");
var isSignatureOptionDirty_1 = require("./utils/isSignatureOptionDirty");
var discardSignatureOption_1 = require("./actions/discardSignatureOption");
var saveSignatureOption_1 = require("./actions/saveSignatureOption");
var SignatureOption = {
    key: 'signature',
    titleStringKey: 'optionTitle_signature',
    searchTermsStringKey: 'optionTitle_signature',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SignatureFull_1.default, null); },
        isDirty: isSignatureOptionDirty_1.default,
        onSave: saveSignatureOption_1.default,
        onDiscard: discardSignatureOption_1.default,
    },
};
exports.default = SignatureOption;
//# sourceMappingURL=SignatureOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-signature-option/lib/SignatureOption.js
// module id = 5005
// module chunks = 2